
if ($body.data('isMobile')) {
    $('input[type=text]').on('keydown', function (e) {
        if (e.keyCode == 13) e.preventDefault();
    });

    if ((pageType == 'ProductCategory' || pageType == 'ProductCategoryCommon') && $body.data('categoryId') != 0) {
        +function(){
            var target = $("#shop-posts-list .post .thumbnail").first();
            if (!window.location.hash) {
                var offset = target.offset().top - (window.innerHeight - target.outerHeight() - 51);
                //var offset = target.offset().top;
                $('html, body').stop().animate({
                    scrollTop: offset
                }, 1000);
            }
        }();
    }
}


// WEBPACK FOOTER //
// ./assets/javascript/scrolls.js